module.exports = __webpack_public_path__ + "img/insta-1.7d962d79.jpg";